"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _reactJss = require("react-jss");

var _fonts = require("../../styles/fonts");

var _variables = require("../../styles/variables");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import { globalStyles } from "../../styles/global";
var useStyles = (0, _reactJss.createUseStyles)(_objectSpread(_objectSpread({}, _fonts.fontStyles), {}, {
  toastBox: {
    fontFamily: "IranSansX",
    borderRadius: "10px",
    backgroundColor: _variables.colors.ghost,
    border: "1px solid ".concat(_variables.colors.hare),
    boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.1)",
    minWidth: "434px",
    minHeight: "85px",
    display: "flex",
    alignItems: "center",
    direction: "rtl",
    position: "fixed",
    zIndex: "10000",
    left: "40%",
    visibility: "visible",
    animation: "fadein 1s, show 10s 1s, fadeout 1s 10s",
    animationName: "$fadein, $show, $fadeout",
    top: "-100%"
  },
  badge: function badge(props) {
    return {
      position: "absolute",
      backgroundColor: props.type === "warning" ? _variables.colors.bee : props.type === "error" ? _variables.colors.fire : props.type === "information" ? _variables.colors.sky : _variables.colors.kiwi,
      borderRadius: "0 10px 10px 0",
      right: "0",
      width: "59px",
      minHeight: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    };
  },
  badgeIcon: {
    paddingTop: "5px"
  },
  toastContent: {
    "float": "right",
    marginRight: "90px",
    direction: "rtl",
    width: "80%",
    padding: "15px 0 15px 0"
  },
  toastContentType: {
    fontSize: "14px",
    fontWeight: "bold",
    color: _variables.colors.wolf
  },
  toastContentText: {
    fontSize: "14px",
    color: _variables.colors.wolf,
    marginTop: "5px"
  },
  toastAction: {
    position: "absolute",
    left: "0",
    cursor: "pointer",
    padding: "25px 20px 20px 20px"
  },
  hidden: {
    top: "-100%",
    animation: "hidden 0.5s",
    animationName: "$hidden"
  },
  "@keyframes hidden": {
    from: {
      top: "50px",
      opacity: 1
    },
    to: {
      top: 0,
      opacity: 0
    }
  },
  "@keyframes show": {
    from: {
      top: "50px",
      opacity: 1
    },
    to: {
      top: "50px",
      opacity: 1
    }
  },
  "@keyframes fadein": {
    from: {
      top: 0,
      opacity: 0.1
    },
    to: {
      top: "50px",
      opacity: 1
    },
    animationDuration: "8s"
  },
  "@keyframes fadeout": {
    from: {
      top: "50px",
      opacity: 1
    },
    to: {
      top: 0,
      opacity: 0
    }
  }
}), {
  name: 'pds-toast-message'
});
exports.useStyles = useStyles;